import { useState } from "react";
import { PROJECTS } from "@/lib/data";
import { MapPin } from "lucide-react";

export default function Projects() {
  const [active, setActive] = useState(0);
  const project = PROJECTS[active];

  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="py-24 md:py-32 bg-bone text-ink"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="md:col-span-7">
            <span className="tech-rule">03 — Selected Projects</span>
            <h2
              data-testid="projects-heading"
              className="mt-6 font-heading font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.9] tracking-tighter"
            >
              Trusted by India's<br />
              <span className="italic font-medium text-rust">marquee developers.</span>
            </h2>
          </div>
          <p className="md:col-span-4 md:col-start-9 text-graphite leading-relaxed self-end">
            External development scopes executed for Phoenix Group, Hiranandani,
            SAP Labs, Wipro and BMRCL — at malls, campuses, villas and metro
            corridors.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          {/* Visual */}
          <div className="lg:col-span-7 relative aspect-[4/3] lg:aspect-[5/4] overflow-hidden bg-ink border border-ink">
            <img
              key={project.image}
              src={project.image}
              alt={project.name}
              className="w-full h-full object-cover animate-reveal-up"
            />
            <div className="absolute inset-x-0 bottom-0 p-6 md:p-8 bg-gradient-to-t from-ink via-ink/70 to-transparent text-bone">
              <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-rust mb-2">
                {String(active + 1).padStart(2, "0")} / {String(PROJECTS.length).padStart(2, "0")} · {project.client}
              </div>
              <h3 data-testid="project-active-name" className="font-heading font-black text-2xl md:text-4xl tracking-tight leading-tight">
                {project.name}
              </h3>
              <div className="mt-2 flex items-center gap-4 text-bone/70 text-sm">
                <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {project.location}</span>
                <span className="font-mono text-[11px] tracking-widest uppercase">{project.scope}</span>
              </div>
            </div>
          </div>

          {/* List */}
          <div className="lg:col-span-5 border border-ink divide-y divide-ink">
            {PROJECTS.map((p, i) => (
              <button
                key={p.name}
                data-testid={`project-item-${i}`}
                onClick={() => setActive(i)}
                onMouseEnter={() => setActive(i)}
                className={`w-full text-left px-5 md:px-7 py-5 flex items-center justify-between gap-4 group transition-colors ${
                  i === active ? "bg-ink text-bone" : "bg-bone text-ink hover:bg-concrete"
                }`}
              >
                <div className="flex items-baseline gap-4 min-w-0">
                  <span className={`font-mono text-[11px] tracking-[0.2em] ${i === active ? "text-rust" : "text-graphite"}`}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="min-w-0">
                    <div className="font-heading font-bold text-lg md:text-xl tracking-tight truncate">
                      {p.name}
                    </div>
                    <div className={`text-xs ${i === active ? "text-bone/65" : "text-graphite"}`}>
                      {p.client} · {p.location}
                    </div>
                  </div>
                </div>
                <span className={`font-mono text-[10px] tracking-widest uppercase ${i === active ? "text-bone/60" : "text-graphite"}`}>
                  {p.scope.split(" ")[0]}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
